import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestAuthentication } from 'shared/actions/authentication';
import { setGalleryDIYBannerAnalyticsSent } from 'shared/actions/newbuildingBrokerDIY';
import { NewbuildingBrokerGalleryBanner } from 'shared/components/NewbuildingBrokerGalleryBanner';
import { NBSP } from 'shared/constants';
import { NewbuildingBrokerModalsContext } from 'shared/containers/NewbuildingBrokerModalsProvider';
import { selectIsAuthenticated } from 'shared/selectors';
import { selectFullscreenGalleryOpened } from 'shared/selectors/gallery';
import { selectGalleryDIYBannerAnalyticsSent } from 'shared/selectors/newbuildingBrokerDIY';
import { trackDIYEntryPointClick, trackDIYEntryPointShow } from 'shared/utils/newbuildingBroker/DIY';

const ENTRYPOINT = 'card_independent_banner_at_gallery';

export const NewbuildingBrokerGalleryDIYBannerContainer = () => {
  const isFullscreen = useSelector(selectFullscreenGalleryOpened);
  const galleryBannerAnalyticsSent = useSelector(selectGalleryDIYBannerAnalyticsSent);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const { loadingPlace, startMicrofrontOpening } = React.useContext(NewbuildingBrokerModalsContext);
  const isLoading = loadingPlace === ENTRYPOINT;

  const dispatch = useDispatch();

  const handleShow = React.useCallback(() => {
    if (!galleryBannerAnalyticsSent) {
      trackDIYEntryPointShow(ENTRYPOINT);
      dispatch(setGalleryDIYBannerAnalyticsSent());
    }
  }, [dispatch, galleryBannerAnalyticsSent]);

  const handleClick = React.useCallback(() => {
    trackDIYEntryPointClick(ENTRYPOINT);

    if (isAuthenticated) {
      startMicrofrontOpening(ENTRYPOINT);
    } else {
      dispatch(
        requestAuthentication({
          onSuccess: () => () => startMicrofrontOpening(ENTRYPOINT),
        }),
      );
    }
  }, [dispatch, startMicrofrontOpening, isAuthenticated]);

  return (
    <NewbuildingBrokerGalleryBanner
      isFullscreen={isFullscreen}
      title={`Бесплатно найдём новостройку под${NBSP}ваш бюджет`}
      gap="small"
      buttons={
        <ActionAfterViewObserver callback={handleShow} wrapper={false}>
          <Button theme="fill_primary" loading={isLoading} onClick={handleClick}>
            Заполнить заявку
          </Button>
        </ActionAfterViewObserver>
      }
    />
  );
};
